import { mutations } from '@/store.js';
import * as Sentry from "@sentry/vue";
import dayjs from 'dayjs';

export const signInMixin = {
    data() {
        return {
            redirect: null,
        };
    },
    methods: {
        signIn: function () {
            this.error = null
            let body = {
                username: this.username,
                password: this.password
            }
            this.$http.post('/guest-management/v1/auth/signin', body
            ).then(response => {
                console.log("Authentication response from server: ")
                console.log(response)
                if (response.data.reference) {
                    this.authenticated(response);
                }
            }).catch(error => {
                mutations.signOut()
                if (error.response) {
                    if (error.response.status === 401) {
                        this.error = "Incorrect username or password. Please try again."
                    } else if (error.response.status === 429) {
                        if (error.response.headers && error.response.headers['retry-after']) {
                            const retryAfter = error.response.headers['retry-after'];
                            this.error = `Too many login attempts. Please try again after ${retryAfter} seconds.`;
                        } else {
                            this.error = "Too many login attempts. Please try again later.";
                        }
                    } else {
                        this.error = error.response.data.message
                    }
                } else {
                    this.error = "Sorry, we can't seem to reach our servers! Please try again"
                }
                Sentry.captureException(error);
            })
        },
        signInWithToken: function(token) {
            this.error = null
            let body = {
                "token": token,
            }
            console.log(body)
            this.$http.post('/guest-management/v1/auth/signin-token', body
            ).then(response => {
                console.log("Authentication response from server: ")
                console.log(response)
                if (response.data.reference) {
                    this.authenticated(response);
                }
            }).catch(error => {
                mutations.signOut()
                if (error.response) {
                    if (error.response.status === 401) {
                        this.error = "Invalid token. Please try again."
                    } else {
                        this.error = error.response.data.message
                    }
                } else {
                    this.error = "Sorry, we can't seem to reach our servers! Please try again"
                }
                Sentry.captureException(error);
            })        
        },
        checkIfAuthenticated: function(callbackIfUnAuthenticated) {
            console.log('Checking if authenticated')
            this.$http.get('/guest-management/v1/host').then(response => {
                if (response.data) {
                    console.log('Authenticated')
                    this.authenticated(response);
                } else {
                    console.log('Not authenticated, invoking callback')
                    if (callbackIfUnAuthenticated) {
                        callbackIfUnAuthenticated();
                    }
                }
            }).catch(error => {
                console.log(error);
                if (callbackIfUnAuthenticated) {
                    callbackIfUnAuthenticated();
                }
            });
        },
        authenticated(response) {
            console.log("Authenticated")

            const host = response.data;
            console.log(host);
            mutations.signIn(host);

            const expiryMs = response.headers['x-refresh-token-expires-at'];
            const refreshExpiresAt = dayjs(Number(expiryMs));
            console.log('Refresh token expires at:', refreshExpiresAt.format());
            setTimeout(() => {
                console.log('Refresh token expired!');
                mutations.signOut();
                this.$router.push({name: 'SignIn'});
            }, refreshExpiresAt.diff(dayjs(), 'millisecond'));

            if (host.state !== "active") {
                // this.$root.$emit('signed-in', false)
                this.$router.push({name: 'CreateAccount'})
            } else if (host.establishments.length === 0) {
                this.$root.$emit('signed-in', false)
                this.$router.push({name: 'ListEstablishments'})
            } else {
                mutations.setCurrentEstablishmentReference(host.establishments[0].reference)
                this.$root.$emit('signed-in', true)
                if (this.redirect) {
                    console.log('Redirecting to: ' + this.redirect);
                    this.$router.push(this.redirect);
                } else {
                    // if (getters.canShowWhatsApp()) {
                        // this.$router.push({name: 'GuestChats'})
                    // } else {
                        this.$router.push({name: 'TaskCalendar'})
                    // }
                }
            }
        },
    },
    mounted: function() {
        if (this.$route.query.redirect) {
            this.redirect = this.$route.query.redirect;
        }
    }
};